module.exports = __webpack_public_path__ + "static/media/sf_restaurant_0.68336617.jpg";